document.addEventListener('page:loaded', function(product) {
    var addToCartButton = document.querySelector('[data-add-to-cart-sample]'); 
    var variantIdInput = document.querySelector('#variant-id');
    
    // Only set up event listeners if we're on a product page with sample button
    if (!addToCartButton) {
        return; // Exit early if not on a product page with sample button
    }
    
    document.addEventListener('cart:quantity-changed', function(event) { 
        // Refresh button status when quantity changes 
        theme.cart.getCartData().then(refreshButtonStatus).catch((error) => { 
            console.error("Error getting cart data:", error); 
        }); 
    }); 
    window.addEventListener('focus', function() {
        theme.cart.getCartData().then(refreshButtonStatus).catch((error) => { 
            console.error("Error getting cart data:", error); 
        });
    }); 
    
    function refreshButtonStatus(cart) { 
        var uniqueSamples = new Set(); 
        var productInCart = false; 
        var productTitle = ""; 
        
        // Only check for product in cart if variantIdInput exists (product pages only)
        var currentVariantId = variantIdInput ? variantIdInput.value : null;
        
        for (let item of cart.items) { 
            if (item.handle.endsWith('-s') || item.handle.endsWith('s-1')) { 
                uniqueSamples.add(item.variant_id); 
                if (currentVariantId && item.variant_id == currentVariantId) { 
                    productInCart = true; 
                    productTitle = item.title; 
                } 
            } 
        } 
        
        var maxMessageDiv = document.querySelector('.max-message'); 
        var maxMessageP = document.querySelector('#max-message'); 

        if (maxMessageDiv && maxMessageP && addToCartButton) {
            var isDiscontinued = addToCartButton.getAttribute('data-discontinued') === 'true';
            
            if (isDiscontinued) {
                // If product is discontinued, keep it disabled
                maxMessageDiv.style.display = 'none';
                addToCartButton.setAttribute('disabled', '');
                addToCartButton.textContent = 'Sample Discontinued';
            } else if (uniqueSamples.size >= sampleMax && !productInCart) { 
                maxMessageP.style.display = 'block'; 
                maxMessageDiv.style.display = 'block'; 
                addToCartButton.setAttribute('disabled', ''); 
                addToCartButton.textContent = 'MAX SAMPLES REACHED'; 
            } else if (productInCart) { 
                maxMessageP.textContent = '1 ' + productTitle + ' already in the cart!'; 
                maxMessageDiv.style.display = 'block'; 
                addToCartButton.setAttribute('disabled', ''); 
                addToCartButton.textContent = 'SAMPLE ALREADY IN CART'; 
            } else { 
                maxMessageDiv.style.display = 'none'; 
                addToCartButton.removeAttribute('disabled'); 
                addToCartButton.textContent = 'Get a Sample +';
            }
        }
    } 
    
    // Refresh button status immediately upon page load (only if on product page with sample button)
    if (addToCartButton) {
        theme.cart.getCartData().then(cartData => { 
            refreshButtonStatus(cartData); 
            // Save cart data to localStorage 
            localStorage.setItem('cartData', JSON.stringify(cartData)); 
        }).catch((error) => { 
            console.error("Error getting cart data:", error); 
        });
    } 

    if (addToCartButton && variantIdInput) {
    addToCartButton.addEventListener('click', function(event) { 
        event.preventDefault(); 
        var quantityInput = document.querySelector('#quantity');
        var quantity = quantityInput ? quantityInput.value : 1; 
        var variantId = variantIdInput.value; 
        
        // Fetch cart data and refresh button status before adding to cart 
        theme.cart.getCartData().then(cartData => { 
            refreshButtonStatus(cartData); 
            var addButtonIsDisabled = addToCartButton.getAttribute('disabled'); 
            if (addButtonIsDisabled) { 
                return; // Do not add to cart if button is disabled 
            } 
            
            fetch('/cart/add.js', { 
                method: 'POST', 
                headers: { 
                    'Content-Type': 'application/json', 
                    'Accept': 'application/json' 
                }, 
                body: JSON.stringify({ quantity: quantity, id: variantId }) 
            }) 
            .then(response => response.json()) 
            .then(data => { 
                var addToCartEvent = new CustomEvent('ajaxProduct:added', { detail: { product: data } }); 
                document.dispatchEvent(addToCartEvent); 
                theme.cart.getCartData().then(cartData => { 
                    refreshButtonStatus(cartData); 
                    // Save cart data to localStorage 
                    localStorage.setItem('cartData', JSON.stringify(cartData)); 
                }).catch((error) => { 
                    console.error("Error getting cart data:", error); 
                }); 
            }) 
            .catch((error) => { 
                var addToCartErrorEvent = new CustomEvent('ajaxProduct:error', { detail: { errorMessage: error.message } }); 
                document.dispatchEvent(addToCartErrorEvent); 
            }); 
        }).catch((error) => { 
            console.error("Error getting cart data:", error); 
        }); 
    });
    }
    
    // Refresh button status from saved cart data in localStorage upon page load (only if on product page with sample button)
    if (addToCartButton) {
        let savedCartData = localStorage.getItem('cartData'); 
        if (savedCartData) { 
            refreshButtonStatus(JSON.parse(savedCartData)); 
        }
    } 
});
